import { headquartersContact } from "lib/leadFormClient"
import { useTranslations } from "lib/useTranslations.client"

export default function LeadFormError({ testId, message, settings, className }) {
  const { t } = useTranslations()
  const { email, phone } = headquartersContact(settings)

  return (
    <p data-testid={testId} role="alert" className={className}>
      {message}
      {(email || phone) && (
        <>
          {" "}
          {t("forms.error-contact", "You can also contact us at")}{" "}
          {email && <a href={`mailto:${email}`}>{email}</a>}
          {email && phone ? " " : null}
          {phone && <a href={`tel:${phone}`}>{phone}</a>}
          .
        </>
      )}
    </p>
  )
}
